<template>
  <div class="container pt-5 mb-5 z-depth-1">
    <!--Section: Content-->
    <section class="about-tech">
      <!-- Titre -->
      <h2
        class="text-center font-weight-bold mt-5 pt-5 mb-4 pb-2 image-fade-in"
      >
        Une plateforme pensée pour le terrain
      </h2>

      <!-- Intro -->
      <p class="text-center lead mx-auto mb-5 image-fade-in">
        <span class="color-primary">Livratos</span> connecte
        <strong>fournisseurs</strong>, <strong>artisans</strong> et
        <strong>livreurs indépendants</strong> autour d’une seule et même
        plateforme&nbsp;: demandes de courses, suivi,
        <strong>optimisation du chargement</strong> et du dernier kilomètre, le
        tout pensé pour la réalité des <strong>chantiers</strong>, pas pour la
        théorie.
      </p>

      <!-- Grid 4 blocs -->
      <div class="four-section">
        <!-- 1. Fournisseurs -->
        <div class="section-item slide-left card-black">
          <div class="icon-container">
            <i class="fa fa-2x fa-warehouse"></i>
          </div>
          <div class="text-container">
            <h3 class="font-weight-bold mb-3">Fournisseurs matériaux</h3>
            <p>
              Déclenchez vos <strong>livraisons</strong> en quelques clics
              depuis le comptoir ou l’agence. Livratos délègue le transport à
              des <strong>livreurs</strong> qualifiés, tout en vous offrant un
              meilleur service aux clients du BTP.
            </p>
          </div>
        </div>

        <!-- 2. Artisans -->
        <div class="section-item slide-left card-green">
          <div class="icon-container">
            <i class="fa fa-2x fa-hard-hat"></i>
          </div>
          <div class="text-container">
            <h3 class="font-weight-bold mb-3">Artisans sur chantier</h3>
            <p>
              Fini le compagnon qui disparaît 2&nbsp;heures pour
              <strong>aller chercher du matériel</strong>. Vous commandez, un
              <strong>livreur</strong> prend en charge, et la
              <strong>marchandise arrive directement sur chantier</strong>, au
              bon moment.
            </p>
          </div>
        </div>

        <!-- 3. Livreurs -->
        <div class="section-item slide-right card-green section-item-3">
          <div class="icon-container">
            <i class="fa fa-2x fa-truck"></i>
          </div>
          <div class="text-container">
            <h3 class="font-weight-bold mb-3">Livreurs indépendants</h3>
            <p>
              Des missions claires avec type de véhicule, accès
              <strong>chantier</strong> et chargement détaillé. Vous
              <strong>optimisez vos tournées</strong>, limitez les temps morts
              et sécurisez vos revenus.
            </p>
          </div>
        </div>

        <!-- 4. Dernier kilomètre -->
        <div class="section-item slide-right card-black section-item-4">
          <div class="icon-container">
            <i class="fas fa-2x fa-route"></i>
          </div>
          <div class="text-container">
            <h3 class="font-weight-bold mb-3">Pilotage du dernier kilomètre</h3>
            <p>
              Vue d’ensemble sur vos courses, vos zones desservies et vos
              véhicules. Vous <strong>réduisez les trajets à vide</strong>,
              améliorez vos délais et maîtrisez enfin le
              <strong>dernier kilomètre logistique du BTP</strong>.
            </p>
          </div>
        </div>
      </div>
    </section>
    <!--Section: Content-->
  </div>
</template>

<script>
export default {
  name: "AboutTech",
};
</script>

<style lang="scss" scoped>
.color-primary {
  color: $color-primary;
}

.about-tech {
  padding: 0 0 70px;

  @media (min-width: 992px) {
    padding: 0 20px 70px;
  }

  h2 {
    color: $color-text;
  }

  p {
    color: $color-text-grey;
  }

  .four-section {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .section-item {
    display: flex;
    align-items: flex-start;
    padding: 1.6rem 1.8rem;
    border-radius: 0.75rem;
    height: 100%;
    box-shadow: 0 14px 30px rgba(0, 0, 0, 0.12);
  }

  /* Cartes fond vert (couleur Livratos) */
  .card-green {
    background-color: $color-primary;

    h3 {
      color: #ffffff;
    }

    p {
      color: rgba(255, 255, 255, 0.9);
    }

    i {
      color: #000000;
    }
  }

  /* Cartes fond noir */
  .card-black {
    background-color: #000000;

    h3 {
      color: #ffffff;
    }

    p {
      color: rgba(255, 255, 255, 0.88);
    }

    i {
      color: $color-primary;
    }
  }

  .icon-container {
    flex: 0 0 auto;
    margin-right: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .text-container {
    flex: 1;
  }

  @media (max-width: 768px) {
    .section-item-3 {
      order: 2;
    }

    .section-item-4 {
      order: 1;
    }
  }
}
</style>
